import "../css/constants.css";
import Navbar from "../components/Navbar.jsx";
import Presentation from "../components/Presentation.jsx";
import Footer from "../components/Footer.jsx";
import Transition from "../components/Transition.jsx";
import React, {useEffect, useRef, useState} from "react";
import {motion} from "framer-motion";
import background from '../assets/images/section1-back2_upscayl_5x_realesrgan-x4plus-3.webp';
import backgroundMobile
    from '../assets/images/section1-back3_upscayl_5x_realesrgan-x4plus_upscayl_4x_realesrgan-x4plus_upscayl_2x_realesrgan-x4plus.webp';
import Picrow1 from "../assets/images/pic-row-1_upscayl_3x_realesrgan-x4plus.webp";
import Picrow2 from "../assets/images/luxury-helicopters-promo-1.png";
import Picrow3 from "../assets/images/Benetti-Motopanfilo-37M-3-2048x1338-1.jpeg";
import Picrow4 from "../assets/images/taa_medizinischeassistance_949x345.jpeg";
import Picbig1 from "../assets/images/Capture d’écran 2025-08-03 à 19.58.31_upscayl_3x_realesrgan-x4plus.webp";
import Picbig2 from "../assets/images/653172c9fde291ae19837766_Eurocopter-EC130-_H130_-Exterior-min_upscayl_3x_realesrgan-x4plus.webp";
import OK from "../assets/images/check.png";
import QuoteForm from "../components/Quotation";
import {useWindowDimensions} from "../contexts/WindowDimensionsContext";
import {Link, scroller} from "react-scroll";
import HomeTexts from "../assets/jsons/Home.json";
import PicRow1 from "../assets/images/rapide.png";
import PicRow2 from "../assets/images/appel-telephonique.png";
import PicRow3 from "../assets/images/bouclier.png";
import {FaArrowRight} from "react-icons/fa";
import ServicesJson from "../assets/jsons/services.json";
import TestimonialsJson from "../assets/jsons/testimonials.json";
import GlobalJson from "../assets/jsons/Global.json";

const GOLD = "#C1A45F";

const services = [
    {
        title: "Réactivité absolue",
        desc: "Nous répondons et organisons en quelques minutes, 24/7.",
        img: PicRow1,
    },
    {
        title: "Disponibilité sur-mesure",
        desc: "Un interlocuteur unique, présent à chaque étape.",
        img: PicRow2,
    },
    {
        title: "Discrétion & sécurité",
        desc: "Standards premium de sécurité et confidentialité.",
        img: PicRow3,
    },
];

const testimonials = [
    {
        name: "Lucien D.",
        role: "Dirigeant",
        quote:
            "Avanty Jet a transformé un déplacement banal en un moment d’exception. Discrétion, précision, excellence.",
    },
    {
        name: "Élodie S.",
        role: "Influenceuse voyage",
        quote:
            "Jamais je n’avais vécu un service aussi personnalisé — du sur-mesure à l’état pur.",
    },
];

function SectionTitle({eyebrow, title, subtitle}) {
    return (
        <div className="text-center">
            {eyebrow && <p className="uppercase text-sm tracking-widest text-white/60 mb-2">{eyebrow}</p>}
            <h2 className="text-3xl sm:text-4xl font-extrabold" style={{color: GOLD}}>{title}</h2>
            {subtitle && <p className="mt-3 text-white/80 max-w-4xl mx-auto">{subtitle}</p>}
        </div>
    );
}

function DemanderDevisButton({language}) {
    const handleSmoothScroll = (e) => {
        e.preventDefault();
        const target = document.querySelector('#quotation');
        if (target) {
            target.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <motion.div whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="flex justify-center">
            <a
                href="#quotation"
                onClick={handleSmoothScroll}
                className="px-10 py-4 rounded-full bg-white text-black font-semibold shadow-lg flex items-center hover:bg-gray-100 transition"
            >
                {GlobalJson.availableLanguages[language].ctaButton}
                <FaArrowRight className="ml-2"/>
            </a>
        </motion.div>
    );
}

function MainContent({language, setLanguage}) {
    const [selected, setSelected] = useState(0);
    const formRef = useRef(null);
    const [formHeight, setFormHeight] = useState(0);
    const windowDimensions = useWindowDimensions();

    useEffect(() => {
        if (window.location.hash === "#quotation") {
            setTimeout(() => {
                scroller.scrollTo("quotation", {
                    smooth: true,
                    duration: 600,
                    offset: -110,
                    delay: 500,
                });

                window.history.replaceState(null, "", window.location.pathname + window.location.search);
            }, 100);
        }
    }, []);

    const getFormTop = () => {
        if (!windowDimensions.wHCheck(450) && windowDimensions.wWCheck(1000))
            return "calc(100vh + 2rem)";
        if (!windowDimensions.wHCheck(600) && windowDimensions.wWCheck(1000))
            return "calc(100vh - 4rem)";
        if (!windowDimensions.wHCheck(700) && windowDimensions.wWCheck(1000))
            return "calc(100vh - 8rem)";
        if (!windowDimensions.wHCheck(800) && windowDimensions.wWCheck(1000))
            return "calc(100vh - 10rem)";
        if (!windowDimensions.wHCheck(900) && windowDimensions.wWCheck(1000))
            return "calc(100vh - 20rem)";
        if (!windowDimensions.wHCheck(1000) && windowDimensions.wWCheck(1000))
            return "calc(100vh - 20rem)";
        return windowDimensions.wWCheck(700) ? "calc(100vh - 21rem)" : windowDimensions.wWCheck(400) ? "calc(100vh - 26rem)" : windowDimensions.wWCheck(385) ? "calc(100vh - 24rem)" : "calc(100vh - 18rem)";
    };

    return (
        <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.7}}
            className="flex-1 z-10"
        >
            <div className="relative z-20">
                <Navbar language={language} setLanguage={setLanguage}/>
            </div>

            <div
                className={`relative min-h-screen bg-cover ${windowDimensions.wHCheck(800) ? "bg-bottom" : "bg-center"} z-10`}
                style={{
                    backgroundImage: `url(${
                        windowDimensions.wWCheck(700) ? background : backgroundMobile
                    })`,
                }}
            >
                <Presentation language={language}/>

                <motion.div
                    className="absolute w-full z-50 transition-all duration-500 ease-in-out"
                    style={{top: getFormTop()}}
                    id="quotation"
                >
                    <QuoteForm selectedIndex={selected} setSelectedIndex={setSelected} formRef={formRef}
                               setFormHeight={setFormHeight} language={language} setLanguage={setLanguage}/>
                </motion.div>
            </div>

            <div className="bg-myDarkBlue w-full flex flex-col items-center relative z-[1]">
                <div
                    className="max-w-[1580px] w-full mx-auto px-4 flex flex-col lg:flex-row justify-around items-center gap-12 lg:gap-0"
                    style={{marginTop: `${windowDimensions.wWCheck(700) ? formHeight - 50 : windowDimensions.wWCheck(380) ? formHeight - 130 : formHeight - 10}px`}}
                >
                    <div className="flex flex-col justify-center items-center lg:items-start text-center lg:text-left">
                        <motion.div initial={{opacity: 0, y: 50}} animate={{opacity: 1, y: 0}}
                                    transition={{duration: 0.5}}>
                            <p className="text-4xl md:text-5xl font-bold text-white">{HomeTexts.availableLanguages[language].title1}</p>
                            <p className="text-4xl md:text-5xl font-bold text-white mt-4 lg:translate-x-36">{HomeTexts.availableLanguages[language].title2}</p>
                            <p className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mt-4 lg:translate-x-20">{HomeTexts.availableLanguages[language].title3}</p>
                        </motion.div>
                    </div>

                    <div
                        className="flex flex-col justify-center items-center lg:items-start text-center lg:text-left xl:w-[500px]">
                        <motion.div className="w-full max-w-2xl">
                            {[HomeTexts.availableLanguages[language].bullets[0],
                                HomeTexts.availableLanguages[language].bullets[1],
                                HomeTexts.availableLanguages[language].bullets[2],
                                HomeTexts.availableLanguages[language].bullets[3],
                                HomeTexts.availableLanguages[language].bullets[4],
                                HomeTexts.availableLanguages[language].bullets[5]].map((item, i) => (
                                <div key={i} className="flex items-center py-3 px-6">
                                    {!windowDimensions.wWCheck(450) &&
                                        <img src={OK} alt="OK icon" className="w-8 h-8 mr-3 flex-shrink-0"/>}
                                    {windowDimensions.wWCheck(450) &&
                                        <div className="border-b-4 border-[#C1A45F] w-[10px] mr-4"></div>}
                                    <p className="text-white text-lg font-semibold whitespace-nowrap">{item}</p>
                                    {windowDimensions.wWCheck(450) &&
                                        <div className="border-b-4 border-[#C1A45F] flex-grow ml-4"></div>}
                                    {windowDimensions.wWCheck(450) &&
                                        <img src={OK} alt="OK icon" className="w-8 h-8 ml-4 flex-shrink-0"/>}
                                </div>
                            ))}
                        </motion.div>
                        <p className="mt-8 text-white pr-6 max-w-[450px] text-center lg:text-left text-base leading-relaxed mx-auto">
                            {HomeTexts.availableLanguages[language].paragraph}
                        </p>
                    </div>
                </div>

                <div className="w-full bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                    <div className="max-w-[1580px] mx-auto px-6 sm:px-8 md:px-12 lg:px-16 py-20 mt-56">
                        <motion.div
                            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                        >
                            {[
                                {
                                    img: Picrow1,
                                    title: HomeTexts.availableLanguages[language].cards[0].title,
                                    desc: HomeTexts.availableLanguages[language].cards[0].desc,
                                },
                                {
                                    img: Picrow2,
                                    title: HomeTexts.availableLanguages[language].cards[1].title,
                                    desc: HomeTexts.availableLanguages[language].cards[1].desc,
                                },
                                {
                                    img: Picrow3,
                                    title: HomeTexts.availableLanguages[language].cards[2].title,
                                    desc: HomeTexts.availableLanguages[language].cards[2].desc,
                                },
                                {
                                    img: Picrow4,
                                    title: HomeTexts.availableLanguages[language].cards[3].title,
                                    desc: HomeTexts.availableLanguages[language].cards[3].desc,
                                },
                            ].map(({ img, title, desc }, i) => (
                                <div
                                    key={i}
                                    className="flex flex-col items-center text-center"
                                >
                                    {/* Image container responsive */}
                                    <div className="w-full max-w-md aspect-[16/9] rounded-3xl overflow-hidden shadow-lg">
                                        <img
                                            className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
                                            src={img}
                                            alt={title}
                                        />
                                    </div>

                                    {/* Texts */}
                                    <p className="text-xl md:text-2xl text-white font-bold mt-4">
                                        {title}
                                    </p>
                                    <div className="border-b-4 border-[#C1A45F] w-24 md:w-40 lg:w-56 mx-auto mt-2" />
                                    <p className="text-sm md:text-base text-white mt-3 leading-relaxed px-2">
                                        {desc}
                                    </p>
                                </div>
                            ))}
                        </motion.div>
                    </div>
                </div>


                <div className="max-w-[1580px] mx-auto mt-56 px-4">
                    <motion.div className="flex flex-col items-center" initial={{opacity: 0, y: 50}}
                                animate={{opacity: 1, y: 0}} transition={{duration: 0.5}}>
                        <div className="border-b-4 border-[#C1A45F] w-72 sm:w-96 mb-10"/>
                        {/*<p className="text-2xl text-white font-bold text-center">{HomeTexts.availableLanguages[language].qualityTitle}</p>*/}
                        <p className="text-white text-center mt-3 max-w-[780px] mx-6 text-sm sm:text-base">{HomeTexts.availableLanguages[language].qualityText}</p>
                        <div className="border-b-4 border-[#C1A45F] w-72 sm:w-96 mt-14"/>
                    </motion.div>
                </div>

                <div className="max-w-[1580px] mx-auto w-full mt-56 px-4 flex flex-col-reverse xl:flex-row justify-around items-center gap-12">
                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="w-full max-w-md sm:max-w-[400px] md:max-w-[800px] xl:max-w-lg"
                    >
                        <div className="rounded overflow-hidden aspect-[16/9]">
                            <img
                                src={Picbig1}
                                alt="Jet Privé"
                                className="w-full h-full object-cover transform transition-transform duration-300 hover:scale-105"
                            />
                        </div>
                    </motion.div>

                    {/* Texte */}
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-center xl:text-left max-w-xl xl:max-w-lg"
                    >
                        <p className="text-4xl md:text-5xl xl:text-5xl font-bold text-white xl:-translate-x-44">
                            {HomeTexts.availableLanguages[language].block1.line1}
                        </p>
                        <p className="text-4xl md:text-5xl xl:text-3xl font-bold text-white mt-4 mb-2 xl:-translate-x-10">
                            {HomeTexts.availableLanguages[language].block1.line2}
                        </p>
                        <p className="text-4xl md:text-5xl xl:text-7xl font-bold text-white xl:-translate-x-28">
                            {HomeTexts.availableLanguages[language].block1.line3}
                        </p>
                    </motion.div>
                </div>

                <div className="max-w-[1580px] mx-auto w-full mt-56 px-4 flex flex-col-reverse xl:flex-row justify-around items-center gap-12">
                    {/* Texte */}
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-center xl:text-left max-w-xl xl:max-w-lg relative z-10"
                    >
                        <p className="text-4xl md:text-5xl xl:text-5xl font-bold text-white leading-tight xl:translate-x-20">
                            {HomeTexts.availableLanguages[language].block2.line1}
                        </p>
                        <p className="text-4xl md:text-5xl xl:text-3xl font-bold text-white mt-4 mb-2 leading-tight xl:translate-x-52">
                            {HomeTexts.availableLanguages[language].block2.line2}
                        </p>
                        <p className="text-4xl md:text-5xl xl:text-7xl font-bold text-white leading-tight xl:translate-x-36">
                            {HomeTexts.availableLanguages[language].block2.line3}
                        </p>
                    </motion.div>

                    {/* Image */}
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="w-full max-w-md sm:max-w-[400px] md:max-w-[800px] xl:max-w-lg relative z-0"
                    >
                        <div className="rounded overflow-hidden aspect-[16/9]">
                            <img
                                src={Picbig2}
                                alt="Hélicoptère Privé"
                                className="w-full h-full object-cover transform transition-transform duration-300 hover:scale-105"
                            />
                        </div>
                    </motion.div>
                </div>



                {/*<div className="max-w-[1580px] mx-auto w-full mt-40 px-4 flex flex-col lg:flex-row justify-around items-center gap-12">*/}
                {/*    <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-center lg:text-left">*/}
                {/*        <p className="text-4xl md:text-5xl lg:text-5xl font-bold text-white lg:translate-x-28">{HomeTexts.availableLanguages[language].block2.line1}</p>*/}
                {/*        <p className="text-4xl md:text-5xl lg:text-3xl font-bold text-white mt-4 mb-2 lg:translate-x-56">{HomeTexts.availableLanguages[language].block2.line2}</p>*/}
                {/*        <p className="text-4xl md:text-5xl lg:text-7xl font-bold text-white lg:translate-x-44">{HomeTexts.availableLanguages[language].block2.line3}</p>*/}
                {/*    </motion.div>*/}
                {/*    <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-[320px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[600px] mx-14 md:mx-0">*/}
                {/*        <img src={Picbig2} alt="Voyage de Groupe" className="w-full h-auto rounded object-cover" />*/}
                {/*    </motion.div>*/}
                {/*</div>*/}

                {/*/!* Esprit AvantyJet *!/*/}
                {/*<section className="text-center mb-32 px-6 sm:px-10 w-full mt-40">*/}
                {/*    <motion.div*/}
                {/*        initial={{ opacity: 0 }}*/}
                {/*        whileInView={{ opacity: 1 }}*/}
                {/*        viewport={{ once: true }}*/}
                {/*        transition={{ duration: 0.5 }}*/}
                {/*    >*/}
                {/*        <p className="text-xl sm:text-2xl font-light tracking-wider text-white/70">{GlobalTexts.availableLanguages[language].spiritTitle1}</p>*/}
                {/*        <h2 className="text-4xl sm:text-6xl font-bold border-b-4 border-[#C1A45F] inline-block mt-2 pb-3">{GlobalTexts.availableLanguages[language].spiritTitle2}</h2>*/}
                {/*    </motion.div>*/}

                {/*    <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-10 max-w-3xl mx-auto">*/}
                {/*        {[{ img: Picrowadvantages1, label: GlobalTexts.availableLanguages[language].spiritItems[0] },*/}
                {/*            { img: Picrowadvantages2, label: GlobalTexts.availableLanguages[language].spiritItems[1] },*/}
                {/*            { img: Picrowadvantages3, label: GlobalTexts.availableLanguages[language].spiritItems[2] }].map(({ img, label }, i) => (*/}
                {/*            <motion.div*/}
                {/*                key={i}*/}
                {/*                whileHover={{ scale: 1.05 }}*/}
                {/*                transition={{ type: "spring", stiffness: 250 }}*/}
                {/*                className="flex flex-col items-center text-center"*/}
                {/*            >*/}
                {/*                <img src={img} alt={label} className="w-24 h-24" />*/}
                {/*                <p className="text-xl font-medium mt-4">{label}</p>*/}
                {/*            </motion.div>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</section>*/}

                {/*/!* CTA *!/*/}
                {/*<section className="relative w-full px-10 sm:px-10 pb-32">*/}
                {/*    <motion.div*/}
                {/*        initial={{ opacity: 0, y: 40 }}*/}
                {/*        whileInView={{ opacity: 1, y: 0 }}*/}
                {/*        viewport={{ once: true }}*/}
                {/*        transition={{ duration: 0.5 }}*/}
                {/*        className="max-w-4xl mx-auto text-center"*/}
                {/*    >*/}
                {/*        <p className="text-4xl sm:text-6xl font-extrabold leading-tight">*/}
                {/*            <span className="block mb-2 text-[#C1A45F]">{GlobalTexts.availableLanguages[language].ctaTitle}</span>*/}
                {/*            {GlobalTexts.availableLanguages[language].ctaSubtitle}*/}
                {/*        </p>*/}

                {/*        <div className="mt-10">*/}
                {/*            <Link*/}
                {/*                className={classNames(*/}
                {/*                    "inline-block px-8 py-4 rounded-full bg-[#C1A45F] text-myDarkBlue font-semibold text-lg hover:bg-white transition-all duration-300 shadow-lg hover:shadow-amber-400/50"*/}
                {/*                )}*/}
                {/*                smooth={true}*/}
                {/*                duration={500}*/}
                {/*                to={"quotation"}*/}
                {/*                offset={-110}*/}
                {/*            >*/}
                {/*                {GlobalTexts.availableLanguages[language].ctaButton}*/}
                {/*            </Link>*/}
                {/*        </div>*/}
                {/*    </motion.div>*/}
                {/*</section>*/}
            </div>
            {/* BRAND PROMISE */}
            <section className="pt-40 pb-16 bg-gradient-to-b from-myDarkBlue via-[#0f172a] to-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6">
                    <SectionTitle
                        eyebrow={ServicesJson.availableLanguages[language].title1}
                        title={ServicesJson.availableLanguages[language].title2}
                        subtitle={ServicesJson.availableLanguages[language].title3}
                    />

                    <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <motion.div
                                key={i}
                                whileHover={{y: -6}}
                                className="p-6 rounded-2xl bg-black/20 border border-white/20 shadow-lg"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div className="flex items-center gap-4">
                                    <img src={s.img} alt={s.title} className="w-16 h-16"/>
                                    <div>
                                        <h4 className="text-xl font-semibold text-white">{ServicesJson.availableLanguages[language].services[i].title}</h4>
                                        <p className="text-white/75 mt-1">{ServicesJson.availableLanguages[language].services[i].desc}</p>
                                    </div>
                                </div>
                                <div className="mt-6 text-sm text-white/60 flex justify-center">
                                    {ServicesJson.availableLanguages[language].services[i].bottom}
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* TESTIMONIALS */}
            <section className="py-16 bg-myDarkBlue">
                <div className="max-w-7xl mx-auto px-6 text-center">
                    <SectionTitle eyebrow={TestimonialsJson.availableLanguages[language].title}
                                  title={TestimonialsJson.availableLanguages[language].subtitle}/>

                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                initial={{opacity: 0, y: 20}}
                                whileInView={{opacity: 1, y: 0}}
                                whileHover={{y: -6}}
                                viewport={{once: true}}
                                className="relative p-6 rounded-2xl bg-black/20 border border-white/10 overflow-hidden bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.05),transparent_70%)]"
                                style={{
                                    boxShadow: `
    0 -6px 10px rgba(255, 255, 255, 0.1),
    0 -8px 20px rgba(255, 255, 255, 0.05)
  `
                                }}
                            >
                                <div
                                    className="absolute -top-4 left-0 w-full h-4 pointer-events-none"
                                    style={{
                                        boxShadow: "0 0 10px 2px rgba(255, 255, 255, 0.2)",
                                        maskImage: "linear-gradient(to bottom, white, transparent)",
                                        WebkitMaskImage: "linear-gradient(to bottom, white, transparent)"
                                    }}
                                />

                                <p className="italic text-white/80">{TestimonialsJson.availableLanguages[language].testimonials[i].quote}</p>
                                <p className="mt-4 font-semibold text-white">{TestimonialsJson.availableLanguages[language].testimonials[i].author}</p>
                                <p className="text-sm text-white/60">{TestimonialsJson.availableLanguages[language].testimonials[i].role}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <section className="pt-10 pb-32 bg-myDarkBlue text-center">
                <h2 className="text-4xl font-extrabold mb-4"
                    style={{color: GOLD}}>{GlobalJson.availableLanguages[language].ctaTitle}</h2>
                <p className="text-white/80 max-w-2xl mx-auto mb-8">{GlobalJson.availableLanguages[language].contact}</p>
                <div className="flex items-center justify-center gap-4">
                    <DemanderDevisButton language={language}/>
                </div>
            </section>
            <Footer language={language}/>
        </motion.div>
    )
        ;
}

function Home({language, setLanguage}) {
    const [isTransitionVisible, setIsTransitionVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTransitionVisible(false);
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {isTransitionVisible ? (
                <Transition/>
            ) : (
                <MainContent language={language} setLanguage={setLanguage}/>
            )}
        </div>
    );
}

export default Home;